import { defineMessages } from "react-intl";

export default defineMessages({
    selectDrawerToConfigure: {
        id: "selectDrawerToConfigure",
        defaultMessage: "Select drawer to configure"
    }
});